var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-btn",
    _vm._b(
      {
        attrs: {
          color: "primary",
          flat: _vm.isFlat,
          icon: !!_vm.buttonIcon,
          small: _vm.isSmall,
          loading: _vm.isLoading,
          disabled: _vm.isLoading || _vm.disabled
        },
        on: {
          click: function($event) {
            $event.stopPropagation()
            return _vm.click.apply(null, arguments)
          }
        }
      },
      "v-btn",
      _vm.$attrs,
      false
    ),
    [
      !!_vm.buttonText
        ? [_vm._v(_vm._s(_vm.buttonText))]
        : [_c("v-icon", [_vm._v(_vm._s(_vm.buttonIcon))])],
      _vm._v(" "),
      _vm._t("icon")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ab322d5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ab322d5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoaderButton.vue
// module id = null
// module chunks = 